// extracted by mini-css-extract-plugin
export default {"root":"MaxButton_root__YwOoj","disabled":"MaxButton_disabled__pmR8k"};